import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createLabelsSlice } from './actions';
import { LabelsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useLabelsStore = create<LabelsStore>()(
  persist(
    (set, get, store) => ({
      ...createLabelsSlice(set, get, store),
    }),
    {
      name: ZustandStores.INBOX_LABELS,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
